import {CommonHelper} from "../CommonHelper";
import React, {useContext} from "react";
import {AuthContext} from "../../providers/AuthProvider";

const Footer = () => {
    const {getContactEmail, user} = useContext(AuthContext);

    const contactEmail = getContactEmail();
    const isAuthenticated = !!user;

    return <footer className="login-footer">
        &copy; Copyright {new Date().getFullYear()}, Bouygues Immobilier | {CommonHelper.getBuildVersion()}
        {contactEmail && <> | <a href={`mailto:${contactEmail}`} target="_blank" rel="noreferrer">Contact</a></>}
        {isAuthenticated && <> | <a href={CommonHelper.getApiDocUrl()} target="_blank" rel="noreferrer">API Doc</a></>}
    </footer>
};

export default Footer;
